import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "pd-search__panel" }
const _hoisted_3 = { class: "pd-search__field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "11",
    cy: "11",
    r: "7",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m20 20-3.5-3.5",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round"
  })
], -1 /* HOISTED */)
const _hoisted_5 = { class: "pd-visually-hidden" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("kbd", null, "Esc", -1 /* HOISTED */)
const _hoisted_8 = {
  key: 0,
  class: "pd-search__results",
  role: "listbox"
}
const _hoisted_9 = ["aria-selected"]
const _hoisted_10 = ["href", "onMousemove"]
const _hoisted_11 = {
  key: 1,
  class: "pd-search__empty"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "pd-search",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": $props.labels.placeholder,
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.$emit('close')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString($props.labels.placeholder), 1 /* TEXT */),
        _withDirectives(_createElementVNode("input", {
          ref: "input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.query) = $event)),
          type: "search",
          placeholder: $props.labels.placeholder,
          autocomplete: "off",
          onKeydown: $setup.onKey
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6), [
          [_vModelText, $setup.query]
        ]),
        _hoisted_7
      ]),
      ($setup.results.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.results, (page, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: page.route,
                role: "option",
                "aria-selected": index === $setup.cursor
              }, [
                _createElementVNode("a", {
                  href: page.route,
                  class: _normalizeClass({ 'is-active': index === $setup.cursor }),
                  onMousemove: $event => ($setup.cursor = index)
                }, [
                  _createElementVNode("strong", null, _toDisplayString(page.title), 1 /* TEXT */),
                  _createElementVNode("small", null, _toDisplayString(page.section), 1 /* TEXT */)
                ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_10)
              ], 8 /* PROPS */, _hoisted_9))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString($props.labels.empty), 1 /* TEXT */))
    ])
  ], 8 /* PROPS */, _hoisted_1))
}